"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var end2end_1 = require("@hudled/end2end");
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var PlanRulesDropdown_1 = __importDefault(require("./CellComponents/PlanRulesDropdown"));
var selectors_1 = require("./selectors");
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD;
var tableConf = {
    headersMap: {
        'rechVendor.name': 'Vendor',
        name: 'Plan',
        count: '',
        excludedCount: '',
        newChargesCount: '',
        invoicedCount: '',
        totalInAccFirmCurrency: 'Total charges',
        totalInvoicedInAccFirmCurrency: 'Invoiced',
        totalNewInAccFirmCurrency: 'New',
        totalExcludedInAccFirmCurrency: 'Excluded',
        isExcluded: 'Rule',
    },
    config: {
        selector: selectors_1.selectSortedFetchedPlans,
    },
    row: {
        hoverable: true,
        highlightInputs: true,
    },
    fieldOverrides: {
        totalInAccFirmCurrency: { money: {} },
        totalExcludedInAccFirmCurrency: { money: {} },
        totalNewInAccFirmCurrency: { money: {} },
        totalInvoicedInAccFirmCurrency: { money: {} },
    },
    cells: [
        {
            field: 'rechVendor.name',
            cell: { width: LG },
            avatar: { size: 'xxs' },
            truncate: {},
            footerAggregate: 'countUniq',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Vendor'),
        },
        {
            field: 'name',
            cell: { width: XL },
            truncate: {},
            footerAggregate: 'count',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Plan'),
        },
        {
            fields: ['totalInAccFirmCurrency', 'count'],
            renderFields: [null, (0, end2end_1.handlePlural)('charge')],
            cell: { width: MD },
            footerAggregate: 'sum',
        },
        {
            fields: ['totalInvoicedInAccFirmCurrency', 'invoicedCount'],
            renderFields: [null, (0, end2end_1.handlePlural)('charge')],
            cell: { width: MD },
            footerAggregate: 'sum',
        },
        {
            fields: ['totalNewInAccFirmCurrency', 'newChargesCount'],
            renderFields: [null, (0, end2end_1.handlePlural)('charge')],
            cell: { width: MD },
            footerAggregate: 'sum',
        },
        {
            fields: ['totalExcludedInAccFirmCurrency', 'excludedCount'],
            cell: { width: MD },
            renderFields: [null, (0, end2end_1.handlePlural)('charge')],
            footerAggregate: 'sum',
        },
        {
            footerAggregate: 'countNonEmpty',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Excluded', 'Excluded'),
            field: 'isExcluded',
            cell: { width: MD },
            renderComponent: PlanRulesDropdown_1.default,
        },
    ],
};
exports.default = tableConf;
